import { render, staticRenderFns } from "./TopicList.vue?vue&type=template&id=727071a8&scoped=true&"
import script from "./TopicList.vue?vue&type=script&lang=js&"
export * from "./TopicList.vue?vue&type=script&lang=js&"
import style0 from "./TopicList.vue?vue&type=style&index=0&id=727071a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727071a8",
  null
  
)

export default component.exports